export default "__VITE_ASSET__BRVNgFKx__"